module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg fr 1-611bacaea47e4e7aff2d54e1ddc65166.jpg";